import { render, staticRenderFns } from "./PedidoInfo.vue?vue&type=template&id=6a30f48f&scoped=true"
import script from "./PedidoInfo.vue?vue&type=script&lang=js"
export * from "./PedidoInfo.vue?vue&type=script&lang=js"
import style0 from "./PedidoInfo.vue?vue&type=style&index=0&id=6a30f48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a30f48f",
  null
  
)

export default component.exports